/** CMS page links are relative; HTTP(S) and protocol-relative URLs are external. */
export function isExternalLink(href) {
    return /^(?:https?:)?\/\//i.test(href.trim());
}
export function externalLinkProps(href) {
    return isExternalLink(href)
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {};
}
//# sourceMappingURL=external-link.js.map